import { type CSSProperties } from 'react'
import { type Theme } from '@mui/material/styles'
import { parseToRgb } from 'polished'

export type HexColor = `#${string}`

const isHexColor = (color: string): color is HexColor => color.startsWith('#')

export const getHexColor = (color: string): HexColor => (isHexColor(color) ? color : `#${color}`)

export const isContrasted = (color = '#ffffff'): boolean => {
  const { red, blue, green } = parseToRgb(getHexColor(color))

  // Get YIQ ratio
  const yiq = (red * 299 + green * 587 + blue * 114) / 1000

  return yiq >= 128
}

export const colorOnBackground = (bkgColor = '#ffffff'): string => (isContrasted(bkgColor) ? '#000000' : '#FFFFFF')

export const backgroundUnderColor = (textColor = '#000000'): string => (isContrasted(textColor) ? '#000000' : '#FFFFFF')

export const getComfortClassColor = (theme: Theme, comfortClass?: string): CSSProperties['color'] => {
  switch (comfortClass) {
    case 'FIRST':
      return theme.customPalette.brand.firstClass
    case 'PRO':
      return theme.customPalette.brand.businessFirstClassPro
    case 'SECOND':
    default:
      return theme.customPalette.brand.secondClass
  }
}
